// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradientContainer {
    width: 100%;
    top: 0;
    position: absolute;
    height: var(--gradientBackground-height);
}

.gradientContainer__background {
    width: 100%;
    height: var(--gradientBackground-height);
    position: absolute;
    top: 0;
}

.gradient__svg {
    width: 100%;
    height: 50px;
    position: absolute;
    top: var(--gradientBackground-height);
    transform: translateY(-100%);
}

.gradient__svg__path,
.gradient__svg__defs {
    fill: var(--public-portal-white);
}
`, "",{"version":3,"sources":["webpack://./src/components/gradientBackground/GradientBackground.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,MAAM;IACN,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,4BAA4B;AAChC;;AAEA;;IAEI,gCAAgC;AACpC","sourcesContent":[".gradientContainer {\n    width: 100%;\n    top: 0;\n    position: absolute;\n    height: var(--gradientBackground-height);\n}\n\n.gradientContainer__background {\n    width: 100%;\n    height: var(--gradientBackground-height);\n    position: absolute;\n    top: 0;\n}\n\n.gradient__svg {\n    width: 100%;\n    height: 50px;\n    position: absolute;\n    top: var(--gradientBackground-height);\n    transform: translateY(-100%);\n}\n\n.gradient__svg__path,\n.gradient__svg__defs {\n    fill: var(--public-portal-white);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
